import View from '@/components/atomic/atoms/layout/view/styled';
import type { BasicComponentProps } from '@/typings/generic';
import styled from '@emotion/styled';

const SvgSprite = styled(View)<BasicComponentProps>().withComponent('svg');

export default SvgSprite;
